/* Nova Milano — product page */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const root = (window.NM && window.NM.routes.root) || '/';
  const url = (path) => root.replace(/\/$/, '') + path;
  function toast(msg) {
    const el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(toast.t); toast.t = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }
  async function addItems(items) {
    const res = await fetch(window.NM.routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: 'cart-drawer' })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || window.NM.strings.error);
    const drawer = $('[data-cart-drawer]');
    if (drawer && data.sections && data.sections['cart-drawer']) {
      const doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
      const fresh = $('[data-cart-drawer]', doc);
      if (fresh) drawer.innerHTML = fresh.innerHTML;
    }
    try {
      const cart = await (await fetch(url('/cart.js'))).json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    } catch (_) {}
    const opener = $('[data-cart-open]');
    if (drawer && opener) opener.click(); else window.location.href = window.NM.routes.cart;
    toast(window.NM.strings.added);
  }

  /* Product page v2 (data-pdp) */
  $$('[data-pdp]').forEach((sec) => {
    const json = $('[data-pp-json]', sec);
    const data = json ? JSON.parse(json.textContent) : { variants: [] };
    const colorIndex = typeof data.colorIndex === 'number' ? data.colorIndex : -1;
    const track = $('[data-pp-track]', sec);
    const slides = $$('[data-pp-slide]', sec);
    const thumbs = $$('[data-pp-thumb]', sec);
    const current = $('[data-pp-current]', sec);
    const totalEl = $('[data-pp-total]', sec);
    const form = $('[data-pp-form]', sec);
    const idInput = $('[data-pp-variant]', sec);
    const addBtn = $('[data-pp-add]', sec);
    const addLabel = $('[data-pp-add-label]', sec);
    const buyBtn = $('[data-pp-buy]', sec);
    const stickyBar = $('[data-pp-sticky]', sec);
    const stickyBtn = $('[data-pp-sticky-add]', sec);
    const stickyPrice = $('[data-pp-sticky-price]', sec);
    const priceWrap = $('[data-pp-price]', sec);
    const stock = $('[data-pp-stock]', sec);
    const notify = $('[data-pp-notify]', sec);
    let index = 0;
    let vis = slides.slice();
    let visThumbs = thumbs.slice();

    /* Gallery filtered by selected colour: slides carry data-color (from image alt). */
    function applyColor(color, smooth) {
      const matches = color ? slides.filter((s) => s.dataset.color === color) : [];
      const filter = matches.length > 0;
      slides.forEach((s, n) => {
        const show = !filter || s.dataset.color === color;
        s.hidden = !show;
        if (thumbs[n]) thumbs[n].hidden = !show;
      });
      vis = slides.filter((s) => !s.hidden);
      visThumbs = thumbs.filter((t) => !t.hidden);
      vis.forEach((s) => { const im = s.querySelector('img'); if (im && im.loading === 'lazy') im.loading = 'eager'; });
      if (totalEl) totalEl.textContent = vis.length;
      index = 0;
      goTo(0, smooth);
    }
    function goTo(i, smooth = true) {
      if (!track || !vis.length) return;
      index = Math.max(0, Math.min(vis.length - 1, i));
      track.scrollTo({ left: vis[index].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      mark();
    }
    function mark() {
      if (current) current.textContent = index + 1;
      thumbs.forEach((t) => t.classList.remove('is-active'));
      visThumbs.forEach((t, n) => t.classList.toggle('is-active', n === index));
      const at = visThumbs[index];
      if (at) at.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    const prev = $('[data-pp-prev]', sec), next = $('[data-pp-next]', sec);
    prev && prev.addEventListener('click', () => goTo(index - 1));
    next && next.addEventListener('click', () => goTo(index + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const n = vis.indexOf(slides[parseInt(t.dataset.ppThumb, 10)]);
      if (n >= 0) goTo(n);
    }));
    if (track) {
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const w = track.clientWidth || 1;
          const n = Math.round(track.scrollLeft / w);
          if (n !== index && n < vis.length) { index = n; mark(); }
        });
      }, { passive: true });
    }

    function opts() {
      return $$('.pp__option', sec).map((fs, i) => {
        const c = $('input[data-pp-option="' + i + '"]:checked', fs);
        return c ? c.value : null;
      });
    }
    function markAvailability() {
      const sel = opts();
      $$('input[data-pp-option]', sec).forEach((input) => {
        const i = parseInt(input.dataset.ppOption, 10);
        const test = sel.slice(); test[i] = input.value;
        const ok = data.variants.some((v) => v.available && v.options.every((o, k) => o === test[k]));
        input.closest('.pp-swatch').classList.toggle('is-unavailable', !ok);
      });
    }
    function update(smooth) {
      const sel = opts();
      $$('[data-option-label]', sec).forEach((el, i) => { el.textContent = sel[i] || ''; });
      const v = data.variants.find((x) => x.options.every((o, i) => o === sel[i]));
      const buyable = !!(v && v.available && v.priceCents > 0);
      [addBtn, buyBtn, stickyBtn].forEach((b) => { if (b) b.disabled = !buyable; });
      if (addBtn) addBtn.classList.toggle('pp__btn--soldout', !buyable);
      if (buyBtn) buyBtn.hidden = !buyable;
      const btns = $('[data-pp-buttons]', sec);
      if (btns) btns.classList.toggle('pp__buttons--soldout', !buyable);
      if (addLabel) addLabel.textContent = buyable ? window.NM.strings.addToCart : window.NM.strings.soldOut;
      if (stock) stock.hidden = !(v && v.available);
      if (notify) notify.hidden = !!(v && v.available);
      markAvailability();
      if (colorIndex >= 0) applyColor(sel[colorIndex], smooth !== false);
      if (!v) return;
      idInput.value = v.id;
      if (priceWrap) {
        priceWrap.innerHTML = '<div class="price' + (v.compare ? ' price--sale' : '') + '"><span class="price__now">' + v.price + '</span>' +
          (v.compare ? ' <s class="price__was">' + v.compare + '</s>' : '') + '</div>' +
          (v.pct > 0 ? '<span class="badge badge--sale">-' + v.pct + '%</span>' : '');
      }
      if (stickyPrice) stickyPrice.textContent = v.price;
      const stickyColor = $('[data-pp-sticky-color]', sec);
      if (stickyColor && colorIndex >= 0) stickyColor.textContent = sel[colorIndex] || '';
      if (v.mediaId) {
        const n = vis.findIndex((s) => s.dataset.mediaId === String(v.mediaId));
        if (n >= 0) goTo(n, smooth !== false);
      }
      if (smooth !== false) {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }
    $$('input[data-pp-option]', sec).forEach((i) => i.addEventListener('change', () => update(true)));
    markAvailability();
    if (colorIndex >= 0) {
      const sel = opts();
      applyColor(sel[colorIndex], false);
    }

    // Sticky bar colour swatches (mobile)
    $$('[data-pp-sticky-opt]', sec).forEach((b) => b.addEventListener('click', () => {
      const i = b.dataset.ppStickyOpt, val = b.dataset.value;
      const input = $$('input[data-pp-option="' + i + '"]', sec).find((x) => x.value === val);
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      $$('[data-pp-sticky-opt]', sec).forEach((x) => x.setAttribute('aria-checked', String(x === b)));
      const img = $('[data-pp-sticky-img]', sec);
      if (img && b.dataset.img) img.src = b.dataset.img;
    }));

    // Notify me (sold out)
    const nToggle = $('[data-pp-notify-toggle]', sec), nForm = $('[data-pp-notify-form]', sec);
    if (nToggle && nForm) {
      if ($('.form-success', nForm)) { nForm.hidden = false; nToggle.hidden = true; }
      nToggle.addEventListener('click', () => {
        nForm.hidden = !nForm.hidden;
        nToggle.setAttribute('aria-expanded', String(!nForm.hidden));
        if (!nForm.hidden) { const i = $('input[type="email"]', nForm); i && i.focus(); }
      });
    }

    // Pairs well with (complementary, falls back to related)
    const pairs = $('[data-pp-pairs]', sec);
    if (pairs) {
      const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const money = (cents) => (cents / 100).toLocaleString('hr-HR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
      const load = async (intent) => {
        const r = await fetch(url('/recommendations/products.json') + '?product_id=' + pairs.dataset.productId + '&limit=6&intent=' + intent);
        if (!r.ok) return [];
        return ((await r.json()).products || []).filter((p) => p.available && p.price > 0);
      };
      (async () => {
        try {
          let list = await load('complementary');
          if (!list.length) list = await load('related');
          list = list.slice(0, parseInt(pairs.dataset.limit, 10) || 2);
          if (!list.length) return;
          pairs.innerHTML = '<p class="pairs__title">' + esc(pairs.dataset.title) + '</p><div class="pairs__list">' + list.map((p) => {
            const v = (p.variants || []).find((x) => x.available) || p.variants[0];
            const img = p.featured_image ? (p.featured_image.startsWith('//') ? 'https:' + p.featured_image : p.featured_image) : '';
            const nm = String(p.title).split(' – ')[0];
            const was = p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '';
            return '<div class="pair"><a class="pair__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + (img.includes('?') ? '&' : '?') + 'width=240" alt="' + esc(nm) + '" loading="lazy">' : '') + '</a>' +
              '<div class="pair__body"><a class="pair__name" href="' + esc(p.url) + '">' + esc(nm) + '</a><span class="pair__price">' + money(p.price) + was + '</span>' +
              '<button type="button" class="pair__add" data-pair-add="' + v.id + '">' + esc(pairs.dataset.add) + ' +</button></div></div>';
          }).join('') + '</div>';
          pairs.hidden = false;
          $$('[data-pair-add]', pairs).forEach((b) => b.addEventListener('click', async () => {
            b.disabled = true;
            try { await addItems([{ id: Number(b.dataset.pairAdd), quantity: 1 }]); } catch (err) { toast(err.message); }
            finally { b.disabled = false; }
          }));
        } catch (_) { /* optional */ }
      })();
    }

    async function add() {
      await addItems([{ id: Number(idInput.value), quantity: 1 }]);
    }
    if (form) form.addEventListener('submit', async (e) => {
      e.preventDefault();
      addBtn.disabled = true;
      try { await add(); } catch (err) { toast(err.message); } finally { addBtn.disabled = false; }
    });
    if (buyBtn) buyBtn.addEventListener('click', async () => {
      buyBtn.disabled = true;
      try {
        const res = await fetch(window.NM.routes.cart_add + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
        });
        if (!res.ok) throw new Error((await res.json()).description || window.NM.strings.error);
        window.location.href = url('/checkout');
      } catch (err) { toast(err.message); buyBtn.disabled = false; }
    });
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        stickyBar.hidden = en.isIntersecting || en.boundingClientRect.top > 0;
      }).observe(addBtn);
      stickyBtn && stickyBtn.addEventListener('click', async () => {
        try { await add(); } catch (err) { toast(err.message); }
      });
    }
  });

})();
